// extracted by mini-css-extract-plugin
export default {"root":"PromptGrid_root__bBV12","empty":"PromptGrid_empty__qRyiW","emptyHint":"PromptGrid_emptyHint__DJBJi"};